import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import { withStyles } from '@material-ui/core/styles';

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
};

const styles1 = theme => ({
    success: {
        backgroundColor: green[600],
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    info: {
        backgroundColor: theme.palette.primary.dark,
    },
    warning: {
        backgroundColor: amber[700],
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1),
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
});

function MySnackbarContent(props) {
    const { classes, className, message, onClose, variant, ...other } = props;
    const Icon = variantIcon[variant];

    return (
        <SnackbarContent
            className={classNames(classes[variant], className)}
            aria-describedby="client-snackbar"
            message={
                <span id="client-snackbar" className={classes.message}>
                    <Icon className={classNames(classes.icon, classes.iconVariant)} />
                    {message}
                </span>
            }
            action={[
                <IconButton
                    key="close"
                    aria-label="Close"
                    color="inherit"
                    className={classes.close}
                    onClick={onClose}
                >
                    <CloseIcon className={classes.icon} />
                </IconButton>,
            ]}
            {...other}
        />
    );
}

MySnackbarContent.propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    message: PropTypes.node,
    onClose: PropTypes.func,
    variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
};

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);

const styles2 = theme => ({
    margin: {
        margin: theme.spacing(1),
    },
});

class Notif extends React.Component {
    // componentDidMount = () => {
    //     this.timeout = setTimeout(()=> this.props.onClose(), 5000)
    // }
    // componentWillUnmount = () => {
    //     clearTimeout(this.timeout)
    // }
    render() {
        const { show, close, type, message } = this.props;
        console.log('=============== NOTIF PROPS =====================');
        console.log({ show, close, type, message });
        console.log('====================================');
        let newType = type
        if (newType === "danger"){
            newType = "error"
        }
        return (
        <div >
            <Snackbar
                style={{marginTop : '60px'}}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={show}
                autoHideDuration={3500}
                onClose={close}
            >
                <MySnackbarContentWrapper
                    onClose={close}
                    variant={newType}
                    message={message}
                />
            </Snackbar>
            
        </div>
        );
    }
}


export default withStyles(styles2)(Notif);

// class Notif extends Component{
    
//     fadeOut = () => {
//         this.timer = setTimeout(() => this.props.close(), 5000);
//     }
//     componentWillUnmount(){
//         clearTimeout(this.timer)
//     }

//     render(){
//         // console.log("[PROPS] NOTIF", this.props)
//         const displayClass = (this.props.show || this.props.display === 'fadeInDown') ? "fadeInDown" : "hidden"
//         return(
//             <div>
//                 {displayClass === "fadeInDown" && this.fadeOut()}
//                 <div 
//                     data-growl="container" 
//                     className={`alert alert-${this.props.type} alert-dismissable growl-animated animated ${displayClass} `} 
//                     style={{
//                         position: "fixed", margin: "0px 0px 0px -206px", zIndex: "15000", display: "inline-block", top: "85px", left: "50%", minWidth: "300px"
//                     }}>
                    
//                     {this.props.title && <span data-growl="title"> {this.props.title}: </span> }
//                     <span data-growl="message">{this.props.message}</span>
//                 </div>                
//             </div>
//         )
//     }
// }


// export default Notif;
